import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Award, Ban } from "lucide-react";
import { toast } from "sonner";

export default function CertificatesAdmin() {
    const [items, setItems] = useState([]);
    const load = async () => { const { data } = await api.get("/certificates"); setItems(data.items); };
    useEffect(() => { load(); }, []);
    const revoke = async (id) => {
        if (!window.confirm("Revoke this certificate?")) return;
        await api.post(`/certificates/${id}/revoke`);
        toast.success("Revoked");
        load();
    };
    return (
        <div className="space-y-6" data-testid="admin-certs-page">
            <div>
                <div className="text-xs uppercase tracking-widest font-bold text-muted-foreground">Issued</div>
                <h1 className="font-display text-3xl lg:text-4xl mt-1">Certificates</h1>
            </div>
            <div className="grid gap-3">
                {items.map(c => (
                    <Card key={c.id} className="mx-card" data-testid={`admin-cert-${c.id}`}>
                        <CardContent className="p-5 flex items-center gap-4">
                            <div className="h-11 w-11 rounded-xl bg-amber-gradient flex items-center justify-center text-white"><Award className="h-5 w-5" /></div>
                            <div className="flex-1">
                                <div className="font-bold">{c.student_name}</div>
                                <div className="text-sm text-muted-foreground">{c.course_title}</div>
                                <div className="text-xs font-mono text-muted-foreground mt-1">{c.cert_number}</div>
                            </div>
                            <Badge className={c.status === "ISSUED" ? "bg-[#16A34A] hover:bg-[#16A34A]" : "bg-[#E11D48] hover:bg-[#E11D48]"}>{c.status}</Badge>
                            {c.status === "ISSUED" && <Button variant="outline" size="sm" onClick={() => revoke(c.id)} className="rounded-xl"><Ban className="h-4 w-4 mr-2" /> Revoke</Button>}
                        </CardContent>
                    </Card>
                ))}
                {items.length === 0 && <div className="mx-card p-12 text-center text-muted-foreground">No certificates issued yet</div>}
            </div>
        </div>
    );
}
